import Burger from '../../components/Burger/Burger'
import Header from '../../components/Header/Header'
import css from './Documentation.module.css'

const Documentation = () => {
  return (
    <div className={css.container}>
        <Burger/>
        <Header />
        <div className={css.content}>
            <h1>Документация</h1>
            <p>
              ООО «ФармПрофиПак» — современное предприятие, специализирующееся на выпуске контурной ячейковой 
              упаковки (блистеров). С 2011 года мы стабильно развиваемся, внедряя новые технологии и расширяя 
              производственные мощности. Качество нашей продукции подтверждено партнерами из различных отраслей — 
              фармацевтики, косметологии и пищевой промышленности. Все используемые материалы проходят строгий 
              контроль, что обеспечивает соответствие упаковки самым высоким требованиям.
            </p>
            <div className={css.documentBlock}>
                <a download href="./Перечень_рекомендуемых_мероприятий.pdf" className={css.documentItem}><img src={'/pdf.svg'}/>Специальная оценка условий труда в 2025 г. (Сводная ведомость)</a>
                <a download href="./Сводная ведомость полная.pdf" className={css.documentItem}><img src={'/pdf.svg'}/>Перечень рекомендуемых мероприятий (по результатам СОУТ в 2025 г.)</a>
            </div>
        </div>
    </div>
  )
}

export default Documentation
